import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function useAuth() {
  const [loggedIn, setLoggedIn] = useState(localStorage.getItem("login") === "true");
  const navigate = useNavigate();

  useEffect(() => {
    const logInfo = localStorage.getItem("login");
    setLoggedIn(logInfo === "true");
    if (logInfo === "false") navigate("/");
  }, [navigate]);

  return loggedIn;
}
